var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter AWB No"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchFTCListing($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Short/Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.companyNamelist,
      "id": "companyName",
      "name": "companyName",
      "placeholder": "Select Client Name",
      "label": "label",
      "track-by": "clientbusinessaccountid",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1)], 1), _vm._v(" "), (_vm.defaulthubid) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination Branch")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.HubList,
      "name": "origin",
      "placeholder": "Select Origin",
      "id": "origin",
      "label": "text",
      "select-label": '',
      "track-by": "value",
      "multiple": false,
      "scroll": true,
      "open-direction": "bottom",
      "disabled": true
    },
    model: {
      value: (_vm.desthub),
      callback: function($$v) {
        _vm.desthub = $$v
      },
      expression: "desthub"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.defaulthubid) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination Branch")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.HubList,
      "name": "origin",
      "placeholder": "Select Destination Branch",
      "id": "origin",
      "label": "text",
      "select-label": '',
      "track-by": "value",
      "multiple": true,
      "scroll": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.desthub),
      callback: function($$v) {
        _vm.desthub = $$v
      },
      expression: "desthub"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RAD From date range  ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radFromDate),
      expression: "radFromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "radFromDate",
      "min": _vm.minFromDate,
      "max": _vm.maxFromDate
    },
    domProps: {
      "value": (_vm.radFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.radFromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RAD To date range  ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radToDate),
      expression: "radToDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "radToDate",
      "min": _vm.minToDate,
      "max": _vm.maxToDate
    },
    domProps: {
      "value": (_vm.radToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.radToDate = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Digital Signature Done")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.digitalSignatureOptions,
      "id": "digitalsignature",
      "name": "digitalsignature",
      "placeholder": "Digital Signature Done",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.digitalsignature),
      callback: function($$v) {
        _vm.digitalsignature = $$v
      },
      expression: "digitalsignature"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("IRN Generated")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.digitalSignatureOptions,
      "id": "irngenerated",
      "name": "irngenerated",
      "placeholder": "IRN Generated",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.irngenerated),
      callback: function($$v) {
        _vm.irngenerated = $$v
      },
      expression: "irngenerated"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "5rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchFTCListing
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                              "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" FTC Paid Cash Memo\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "button-container"
  }, [(_vm.selectedShipments.length > 0) ? _c('div', [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Download (Zip)"
    },
    on: {
      "click": function($event) {
        _vm.downloadBulkData()
      }
    }
  }, [_vm._v("Bulk Download")])]) : _c('div', {
    staticClass: "placeholder"
  }), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Bulk Upload"
    },
    on: {
      "click": function($event) {
        _vm.openUploadCashMemo()
      }
    }
  }, [_vm._v("Bulk Upload")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-info",
    attrs: {
      "type": "button",
      "title": "Download Report"
    },
    on: {
      "click": function($event) {
        _vm.downloadReport()
      }
    }
  }, [_vm._v("Report Download")]), _vm._v(" "), _c('b', [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "offset": _vm.offset,
      "selectall": _vm.selectAll
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "scrollable": ""
    },
    on: {
      "ok": function($event) {
        _vm.showPrintCashMemo = false
      }
    },
    model: {
      value: (_vm.showPrintCashMemo),
      callback: function($$v) {
        _vm.showPrintCashMemo = $$v
      },
      expression: "showPrintCashMemo"
    }
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("View/Print Tax Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showPrintCashMemo = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "0.5rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printCashMemo
    }
  }, [_vm._v("Print")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printCashMemoData"
    }
  }, _vm._l((_vm.printAwb), function(item) {
    return _c('FTCMemoDepositSlip', {
      key: item.AWB,
      attrs: {
        "selectedData": item
      }
    })
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.responsedetails = false
      }
    },
    model: {
      value: (_vm.responsedetails),
      callback: function($$v) {
        _vm.responsedetails = $$v
      },
      expression: "responsedetails"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('label', [_c('strong', [_vm._v("Response ")])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.responsedetails = false
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pre', [_vm._v(_vm._s(_vm.responsedata))])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "scrollable": ""
    },
    on: {
      "ok": function($event) {
        _vm.showUploadCashMemo = false
      }
    },
    model: {
      value: (_vm.showUploadCashMemo),
      callback: function($$v) {
        _vm.showUploadCashMemo = $$v
      },
      expression: "showUploadCashMemo"
    }
  }, [_c('b-card', {
    staticStyle: {
      "max-height": "80vh",
      "overflow-y": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.modalLoading
    },
    on: {
      "update:active": function($event) {
        _vm.modalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('label', [_c('strong', [_vm._v("Upload Digitally Signed FTC Invoice")])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeUploadCashMemo()
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "file-upload-container",
    on: {
      "dragenter": _vm.handleDragEnter,
      "dragover": function($event) {
        $event.preventDefault();
        _vm.handleDragOver($event)
      },
      "dragleave": _vm.handleDragLeave,
      "drop": _vm.handleDrop
    }
  }, [_c('div', {
    staticClass: "file-upload",
    on: {
      "click": _vm.openFileInput
    }
  }, [_c('p', [_vm._v("Click here to upload files")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".pdf"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm._v(" "), (_vm.selectedFiles.length > 0) ? _c('div', {
    staticClass: "file-list"
  }, [_c('p', [_vm._v("Selected Files:")]), _vm._v(" "), _c('ul', _vm._l((_vm.selectedFiles), function(file, index) {
    return _c('li', {
      key: index,
      staticClass: "file-item"
    }, [_vm._v("\n              " + _vm._s(file.name) + "\n              "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeFile(index)
        }
      }
    }, [_vm._v("Remove")])])
  })), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-success",
    on: {
      "click": _vm.uploadFiles
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    on: {
      "click": _vm.resetFiles
    }
  }, [_vm._v("Reset")])]) : _vm._e(), _vm._v(" "), (_vm.uplodedRecords.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_vm._v("No. of uploded files : "), _c('strong', [_vm._v(_vm._s(_vm.uplodedRecords.length))])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4"
    }
  }, [_c('b', [_vm._v("AWB")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4"
    }
  }, [_c('b', [_vm._v("Digitally Signed")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4"
    }
  }, [_c('b', [_vm._v("Upload Status")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.uplodedRecords), function(column, index) {
    return (_vm.uplodedRecords.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(column.cashMemoData.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(column.valid == 1 ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(column.valid == 1 ? "Uploaded Successfully" : column.error))])]) : _vm._e()
  }))])]) : _vm._e()])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2546451e","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/FTCPaidCashMemo/FTCPaidCashMemo.component.html
// module id = 1982
// module chunks = 3